export const STORE_KEY = '@@thankYou'
export const GET_CHECKOUT_RESULTS_REQUEST = `${STORE_KEY}/GET_CHECKOUT_RESULTS_REQUEST`
export const GET_CHECKOUT_RESULTS_SUCCESS = `${STORE_KEY}/GET_CHECKOUT_RESULTS_SUCCESS`
export const GET_CHECKOUT_RESULTS_FAILURE = `${STORE_KEY}/GET_CHECKOUT_RESULTS_FAILURE`
export const GET_VALIDATE_TOKEN_REQUEST = `${STORE_KEY}/GET_VALIDATE_TOKEN_REQUEST`
export const GET_VALIDATE_TOKEN_SUCCESS = `${STORE_KEY}/GET_VALIDATE_TOKEN_SUCCESS`
export const GET_VALIDATE_TOKEN_FAILURE = `${STORE_KEY}/GET_VALIDATE_TOKEN_FAILURE`
export const GET_DELIVERY_TRACKING_LINK_REQUEST = `${STORE_KEY}/GET_DELIVERY_TRACKING_LINK_REQUEST`
export const GET_DELIVERY_TRACKING_LINK_SUCCESS = `${STORE_KEY}/GET_DELIVERY_TRACKING_LINK_SUCCESS`
export const GET_DELIVERY_TRACKING_LINK_FAILURE = `${STORE_KEY}/GET_DELIVERY_TRACKING_LINK_FAILURE`
export const GET_DELIVER_REQUEST_LOCATION_REQUEST = `${STORE_KEY}/GET_DELIVER_REQUEST_LOCATION_REQUEST`
export const GET_DELIVER_REQUEST_LOCATION_SUCCESS = `${STORE_KEY}/GET_DELIVER_REQUEST_LOCATION_SUCCESS`
export const GET_DELIVER_REQUEST_LOCATION_FAILURE = `${STORE_KEY}/GET_DELIVER_REQUEST_LOCATION_FAILURE`
